import $ from 'jquery';

$( document ).on('turbolinks:load', function() {
    $(".js-video").modalVideo();
})